'use client'

import React from 'react'
import useCognito from '../../lib/useCognito'

export default function CognitoForm(props: { cognitoScriptID: string, cognitoFormID: string }) {
    useCognito({ cognitoScriptID: props.cognitoScriptID, cognitoFormID: props.cognitoFormID, });
    return (
        <div className="cognito-wrapper">
            <div className="cognito">Loading...</div>
        </div>
    );
};
